import { PreloaderScreen } from '../../gameClient/webgl/preloaderScreen';
import { TimerWebglLoadingHandler } from '../../gameClient/loadingHandler/timerWebglLoadingHandler';
import { sendFakeHardtutorFact } from '../../stat/factHelpers';
import { CurrentPage } from '../../pages/currentPage';
import { addLoginCallback, disableAutoreloadAfterLoginCallbacks } from '../../login/common';

export function runFakeTutorial() {
    window.app.eventInstall();
    $('.landing-page-fake-preloader').fadeIn(1000);
    PreloaderScreen.getInstance().show();
    PreloaderScreen.getInstance().showPreloader();
    let loadingTime = 10000;
    const loadingHandler = new TimerWebglLoadingHandler();
    if (window.app.config?.landings?.fakeHardtutorLoadTime) {
        loadingTime = window.app.config.landings.fakeHardtutorLoadTime * 1000;
    }
    loadingHandler.setTimeToComplete(loadingTime);
    loadingHandler.onPreStart(60);

    $('.fake-hardtutor-screen-popup-continue').on('click', async() => {
        await sendFakeHardtutorFact();
        CurrentPage.reload();
    });

    setTimeout(() => {
        $('.landing-page-fake-hardtutor').fadeIn(1000);
        $('.landing-page-fake-preloader').fadeOut(2000);
    }, loadingTime);
}

export function initFakeHardtutor() {
    disableAutoreloadAfterLoginCallbacks();
    addLoginCallback(async() => {
        await runFakeTutorial();
    });
}


